import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  Spacer,
  colors,
  TextCapitalized,
  triggerToast,
  ButtonDS,
} from "@qivia/ui";
import { useAppSelector } from "../../redux/hooks";
import { selectCompanyGroup } from "../qrCode/vehicleLoginSlice";
import "../../i18n/i18n";
import { useNavigate } from "react-router-dom";
import { Page } from "./Page";

const JTFinancesPhone = () => {
  const { t } = useTranslation();
  return (
    <StyledColumn>
      <StyledFlexNoWrap>
        {t("needHelp.support.sales.first")}
        <Spacer x={1} />
        <ButtonDS
          format={"fill"}
          buttonType={"primary"}
          text={t("needHelp.support.JTFinancesPhone.first")}
          onClick={() => {
            void navigator.clipboard.writeText(
              t("needHelp.support.JTFinancesPhone.first"),
            );
            triggerToast(
              t("needHelp.support.phone.copy.success") || "",
              "valid",
            );
          }}
        />
      </StyledFlexNoWrap>
      <Spacer y={0.5} />
      <StyledFlexNoWrap>
        {t("needHelp.support.sales.second")}
        <Spacer x={1} />
        <ButtonDS
          format={"fill"}
          buttonType={"primary"}
          text={t("needHelp.support.JTFinancesPhone.second")}
          onClick={() => {
            void navigator.clipboard.writeText(
              t("needHelp.support.JTFinancesPhone.second"),
            );
            triggerToast(
              t("needHelp.support.phone.copy.success") || "",
              "valid",
            );
          }}
        />
      </StyledFlexNoWrap>
    </StyledColumn>
  );
};

export const NeedHelpPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const companyGroup = useAppSelector(selectCompanyGroup);
  const isJTFinances = companyGroup === "c6d23e02-ceb8-43a2-a010-4606a3196847";

  return (
    <Page
      title={null}
      returnButton
      withoutHeaderSpacer
      returnButtonAction={() => navigate(-1)}
      backgroundColor={colors.white}
    >
      <StyledSupportContent>
        <StyledColumn>
          <StyledSupportCardTitle>
            <TextCapitalized>{t("needHelp.support.title")}</TextCapitalized>
          </StyledSupportCardTitle>
          <Spacer y={3} />
          <StyledSupportCardSubTitle>
            <TextCapitalized>{t("needHelp.support.faq.title")}</TextCapitalized>
          </StyledSupportCardSubTitle>
          <Spacer y={2} />
          <ButtonDS
            text={t("needHelp.support.faq.button")}
            format={"fill"}
            buttonType={"primary"}
            onClick={() => navigate("/faq")}
          />
          <Spacer y={5} />
          <StyledSupportCardSubTitle>
            <TextCapitalized>
              {t("needHelp.support.phone.title")}
            </TextCapitalized>
          </StyledSupportCardSubTitle>
          <Spacer y={1.5} />
          <StyledFlex>
            <TextCapitalized>
              {isJTFinances
                ? t("needHelp.support.phone.JTFinancesBody")
                : t("needHelp.support.phone.body")}
            </TextCapitalized>
          </StyledFlex>
          <Spacer y={2} />
          <StyledFlex>
            {isJTFinances ? (
              <JTFinancesPhone />
            ) : (
              <ButtonDS
                text={t("needHelp.support.phone")}
                format={"fill"}
                buttonType={"primary"}
                onClick={() => {
                  void navigator.clipboard.writeText(
                    t("needHelp.support.phone.toPaste"),
                  );
                  triggerToast(
                    t("needHelp.support.phone.copy.success") || "",
                    "valid",
                  );
                }}
              />
            )}
          </StyledFlex>
          <Spacer y={4} />
          <StyledSupportCardSubTitle>
            <TextCapitalized>
              {t("needHelp.support.clearStorage.title")}
            </TextCapitalized>
          </StyledSupportCardSubTitle>
          <Spacer y={1.5} />
          <StyledFlex>
            <ButtonDS
              text={t("needHelp.support.clearStorage")}
              format={"fill"}
              buttonType={"secondary"}
              onClick={() => {
                localStorage.clear();
                sessionStorage.clear();
                triggerToast(
                  t("needHelp.support.clearStorage.success") || "",
                  "valid",
                );
                window.location.reload();
              }}
            />
          </StyledFlex>
        </StyledColumn>
      </StyledSupportContent>
    </Page>
  );
};

const StyledSupportContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: 400;
  font-size: 1rem;
  font-style: normal;
  color: ${colors.black};
`;

const StyledSupportCardTitle = styled.div`
  display: flex;
  font-weight: 600;
  font-size: 2.25rem;
`;

const StyledSupportCardSubTitle = styled.div`
  display: flex;
  font-weight: 550;
  font-size: 1.5rem;
`;
const StyledFlex = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const StyledFlexNoWrap = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
`;

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
